
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4dFYb", function(module, exports) {
//
// Securely REST API wrapper
// This includes authentication with Securely's backend
//
// Copyright (c) 2024 Securely. All rights reserved.
// Licensed under the MIT license. See LICENSE file in the project root for details.
//
/**
 * The backend URL to use. Determines whether to use local, development or production endpoints.
 * @type {string}
 */ let $3128ee9f342b282d$var$backendUrl = 'https://prod.securely.id';
/**
 * The auth URL to use. Determines whether to use local, development or production endpoints.
 * @type {string}
 */ let $3128ee9f342b282d$var$authUrl = 'https://auth.securely.id';
/**
 * Counter for generating unique request IDs.
 * @type {number}
 */ let $3128ee9f342b282d$var$requestIdCounter = 1;
/**
 * Sets the backend URL.
 * @param {string} url - The backend URL to use.
 */ function $3128ee9f342b282d$var$setBackendUrl(url) {
    $3128ee9f342b282d$var$backendUrl = url;
}
/**
 * Sets the auth URL.
 * @param {string} url - The auth URL to use.
 */ function $3128ee9f342b282d$var$setAuthUrl(url) {
    $3128ee9f342b282d$var$authUrl = url;
}
/**
 * Sets the backend URL to use the dev environment.
 * This is a convenience function for testing.
 * Note: This function should not be used in production.
 */ function $3128ee9f342b282d$var$setDevMode() {
    $3128ee9f342b282d$var$backendUrl = 'https://dev.securely.id';
    $3128ee9f342b282d$var$authUrl = 'https://auth-dev.securely.id';
}
/**
 * Generates the next unique request ID.
 * @return {number} - The next request ID.
 */ function $3128ee9f342b282d$var$getNextRequestId() {
    return $3128ee9f342b282d$var$requestIdCounter++;
}
/**
 * Initiates Securely authentication flow.
 * @param {string} methodId - The method ID for the authentication.
 * @param {boolean} [useIframe=true] - Whether to use an iframe or a new window for the flow.
 * @return {Promise<Object>} - Resolves with authentication data.
 */ function $3128ee9f342b282d$var$securelyAuth(methodId, useIframe = true) {
    return new Promise((resolve, reject)=>{
        if (useIframe) {
            const overlay = document.createElement('div');
            const container = document.createElement('div');
            const iframe = document.createElement('iframe');
            const closeButton = document.createElement('button');
            const style = document.createElement('style');
            style.textContent = `
              .auth-overlay {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                z-index: 2000;
                display: flex;
                justify-content: center;
                align-items: center;
              }

              .auth-container {
                position: relative;
                border-radius: 20px;
                box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
                overflow: hidden;
                z-index: 2001;
                width: 700px;
                height: 1000px;
              }

              .auth-iframe {
                border: none;
                box-sizing: border-box;
                width: 700px;
                height: 1000px;
              }

              /* No box for small screens */
              @media (max-width: 700px), (max-height: 1000px) {
                .auth-iframe {
                  width: 100vw;
                  height: 100vh;
                }
                .auth-container {
                  border-radius: 0;
                }
              }

              .auth-close-button {
                position: absolute;
                top: 10px;
                right: 10px;
                color: grey;
                border: none;
                background: none;
                font-size: 20px;
                font-weight: bold;
                cursor: pointer;
                z-index: 2002;
                padding: 0;
                outline: none;
              }

              .auth-close-button:hover {
                color: black;
                background: none;
              }

              .auth-close-button:focus {
                outline: none;
              }
            `;
            document.head.appendChild(style);
            overlay.className = 'auth-overlay';
            container.className = 'auth-container';
            iframe.className = 'auth-iframe';
            closeButton.className = 'auth-close-button';
            closeButton.innerHTML = '&times;'; // X symbol for the button
            iframe.src = `${$3128ee9f342b282d$var$authUrl}?methodId=${methodId}`;
            iframe.sandbox = "allow-scripts allow-same-origin allow-forms";
            /* Allow Webauthn within iframe */ iframe.allow = "publickey-credentials-get; publickey-credentials-create";
            container.appendChild(iframe);
            container.appendChild(closeButton);
            overlay.appendChild(container);
            document.body.appendChild(overlay);
            closeButton.addEventListener('click', ()=>{
                document.body.removeChild(overlay);
                reject(new Error('Authentication canceled by user.'));
            });
            iframe.addEventListener('click', (event)=>{
                event.stopPropagation();
            });
        } else {
            const newWindow = window.open(`${$3128ee9f342b282d$var$authUrl}?methodId=${methodId}`, "Securely Authentication", "toolbar=no,scrollbars=no,location=no,statusbar=no,menubar=no,resizable=0,width=700,height=1000");
            newWindow.focus();
        }
        function messageHandler(event) {
            if (event.origin === $3128ee9f342b282d$var$authUrl) {
                window.removeEventListener('message', messageHandler);
                if (useIframe) {
                    const overlay = document.querySelector('.auth-overlay');
                    document.body.removeChild(overlay);
                }
                const receivedData = event.data;
                console.log('Received data from Securely Auth:', receivedData);
                resolve(receivedData);
            }
        }
        window.addEventListener('message', messageHandler);
    });
}
/**
 * Calls Securely API with automatic authentication.
 * @param {string} method - The API method name.
 * @param {string} endpoint - The API endpoint.
 * @param {Array|Object} params - Parameters for the API call.
 * @param {number} chainId - The blockchain chain ID.
 * @param {string} dAppAddress - The dApp address.
 * @param {string} [functionSelector=''] - The function selector (optional).
 * @return {Promise<Object>} - Resolves with API response.
 */ async function $3128ee9f342b282d$var$securelyCallAutoAuth(method, endpoint, params, chainId, dAppAddress, functionSelector = '') {
    const methodId = $3128ee9f342b282d$var$computeMethodId(chainId, dAppAddress, functionSelector);
    // Will call securelyAuth if authentication is required. Only webauthn is supported for now
    return await $3128ee9f342b282d$var$securelyCall(method, endpoint, params, (await $3128ee9f342b282d$var$getProviders(methodId)).result.filter((p)=>p.type.toLowerCase() === "auth" && p.name.toLowerCase() === "webauthn").length !== 0 ? (await $3128ee9f342b282d$var$securelyAuth(methodId)).token : null);
}
/**
 * Makes a POST request to Securely API.
 * @param {string} method - The API method name.
 * @param {string} endpoint - The API endpoint.
 * @param {Array|Object} params - Parameters for the API call.
 * @param {string} [token] - Optional authentication token.
 * @return {Promise<Object>} - Resolves with API response.
 */ async function $3128ee9f342b282d$var$securelyCall(method, endpoint, params, token) {
    function deepConvertBigIntToString(obj) {
        if (typeof obj === 'bigint') return obj.toString();
        if (Array.isArray(obj)) return obj.map(deepConvertBigIntToString);
        if (obj !== null && typeof obj === 'object') return Object.fromEntries(Object.entries(obj).map(([k, v])=>[
                k,
                deepConvertBigIntToString(v)
            ]));
        return obj;
    }
    const resource = `${$3128ee9f342b282d$var$backendUrl}/api/v0/${endpoint}`.replace(/\/$/, '');
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...token && {
                'Authorization': `Bearer ${token}`
            }
        },
        body: JSON.stringify(deepConvertBigIntToString({
            'jsonrpc': '2.0',
            'method': method,
            'params': params,
            'id': $3128ee9f342b282d$var$getNextRequestId()
        }))
    };
    try {
        const response = await fetch(resource, options);
        if (!response.ok) throw new Error(response.error);
        return await response.json();
    } catch (error) {
        console.error('Failed to perform Securely call %s:', method, error);
        throw error;
    }
}
/**
 * Retrieves the list of authentication providers for a specific method.
 * @param {string} methodId - The method ID.
 * @return {Promise<Object>} - Resolves with the list of providers.
 */ function $3128ee9f342b282d$var$getProviders(methodId) {
    return $3128ee9f342b282d$var$securelyCall('getProviders', 'onboarding', {
        methodId: methodId
    });
}
/**
 * Computes a unique method ID based on the input parameters.
 * @param {number} chainId - The blockchain chain ID.
 * @param {string} dAppAddress - The dApp address.
 * @param {string} [functionSelector=''] - The function selector (optional).
 * @return {string} - The computed method ID.
 */ function $3128ee9f342b282d$var$computeMethodId(chainId, dAppAddress, functionSelector = '') {
    dAppAddress = dAppAddress.replace(/^0x/, '');
    functionSelector = functionSelector.replace(/^0x/, '');
    return `${chainId}-${dAppAddress}-${functionSelector}`.replace(/-$/, '').toLowerCase();
}
/**
 * Validates compliance for any transaction. Specify either functionSelector and args, or data.
 * @param {number} chainId - The blockchain chain ID.
 * @param {string} sender - The sender address.
 * @param {string} dAppAddress - The dApp address.
 * @param {number} value - The transaction value in base units.
 * @param {Object|string} data - Either the tx data or the function selector and parameters.
 * @param {List<Tuple<string, number>>} policyParameters.amounts - An array of (token, value) tuples for the policy
 * @param {List<string>} policyParameters.wallets - An array of wallet addresses for the policy
 * @return {Promise<Object>} - Resolves with the compliance validation result.
 */ function $3128ee9f342b282d$var$validateCompliance(chainId, sender, dAppAddress, value, data, policyParameters) {
    const dataIsEncoded = typeof data === 'string' || data instanceof String;
    const functionSelector = dataIsEncoded ? data.replace(/^0x/, '').slice(0, 8) : data.functionSelector;
    const params = dataIsEncoded ? {
        chainId: chainId,
        sender: sender,
        dAppAddress: dAppAddress,
        value: value,
        data: data,
        policyParameters: policyParameters
    } : {
        chainId: chainId,
        sender: sender,
        dAppAddress: dAppAddress,
        value: value,
        functionSelector: functionSelector,
        args: data.args,
        policyParameters: policyParameters
    };
    return $3128ee9f342b282d$var$securelyCallAutoAuth('validate', chainId, params, chainId, dAppAddress, functionSelector);
}
/**
 * Validates a user's compliance status.
 * @param {number} chainId - The blockchain chain ID.
 * @param {string} dAppAddress - The dApp address.
 * @return {Promise<Object>} - Resolves with the user's compliance validation result.
 */ function $3128ee9f342b282d$var$validateUser(chainId, dAppAddress) {
    return $3128ee9f342b282d$var$securelyCallAutoAuth('validate', `${chainId}`, {
        chainId: chainId,
        dAppAddress: dAppAddress
    }, chainId, dAppAddress);
}
/**
 * Fetches a specific policy by its ID.
 * @param {string} id - The policy ID.
 * @param {boolean} [formatted=true] - Whether to return the policy in a formatted structure.
 * @return {Promise<Object>} - Resolves with the policy data.
 */ function $3128ee9f342b282d$var$showPolicyById(id, formatted = true) {
    return $3128ee9f342b282d$var$securelyCall('showPolicy', '', {
        id: id,
        formatted: formatted
    });
}
/**
 * Fetches a policy based on chain ID, dApp address, and function selector.
 * @param {number} chainId - The blockchain chain ID.
 * @param {string} dappAddr - The dApp address.
 * @param {string} functionSelector - The function selector.
 * @param {boolean} [formatted=true] - Whether to return the policy in a formatted structure.
 * @return {Promise<Object>} - Resolves with the policy data.
 */ function $3128ee9f342b282d$var$showPolicy(chainId, dappAddr, functionSelector, formatted = true) {
    return $3128ee9f342b282d$var$showPolicyById($3128ee9f342b282d$var$computeMethodId(chainId, dappAddr, functionSelector), formatted);
}
/**
 * Lists all policies for a given chain ID and dApp address.
 * @param {number} chainId - The blockchain chain ID.
 * @param {string} dappAddr - The dApp address.
 * @return {Promise<Object>} - Resolves with the list of policies.
 */ function $3128ee9f342b282d$var$listPolicies(chainId, dappAddr) {
    return $3128ee9f342b282d$var$securelyCall('listPolicies', '', {
        chainId: chainId,
        dappAddr: dappAddr
    });
}
/**
 * Checks if a smart contract is protected by any policies.
 * @param {number} chainId - The blockchain chain ID.
 * @param {string} dappAddr - The dApp address.
 * @return {Promise<boolean>} - Resolves with true if protected, false otherwise.
 */ async function $3128ee9f342b282d$var$isSCProtected(chainId, dappAddr) {
    return (await $3128ee9f342b282d$var$securelyCall('listPolicies', '', {
        chainId: chainId,
        dappAddr: dappAddr
    })).result.length !== 0;
}
// Export the functions for module usage
if (0, module.exports) module.exports = {
    setBackendUrl: $3128ee9f342b282d$var$setBackendUrl,
    setAuthUrl: $3128ee9f342b282d$var$setAuthUrl,
    setDevMode: $3128ee9f342b282d$var$setDevMode,
    securelyCallAutoAuth: $3128ee9f342b282d$var$securelyCallAutoAuth,
    securelyCall: $3128ee9f342b282d$var$securelyCall,
    getProviders: $3128ee9f342b282d$var$getProviders,
    validateCompliance: $3128ee9f342b282d$var$validateCompliance,
    validateUser: $3128ee9f342b282d$var$validateUser,
    showPolicyById: $3128ee9f342b282d$var$showPolicyById,
    showPolicy: $3128ee9f342b282d$var$showPolicy,
    listPolicies: $3128ee9f342b282d$var$listPolicies,
    isSCProtected: $3128ee9f342b282d$var$isSCProtected
};

});

parcelRegister("gwoQm", function(module, exports) {

$parcel$export(module.exports, "loadingSpinner", () => $c072e7e9da7baaac$export$deaa9e6d912ce6c6);
$parcel$export(module.exports, "errorPopup", () => $c072e7e9da7baaac$export$ec267e3635bd0be4);
$parcel$export(module.exports, "successPopup", () => $c072e7e9da7baaac$export$89dc853842deb0b3);
$parcel$export(module.exports, "formatTimestamp", () => $c072e7e9da7baaac$export$bfe4ac50319c1d9b);
$parcel$export(module.exports, "refreshTooltips", () => $c072e7e9da7baaac$export$a2bc61e91eae259f);
$parcel$export(module.exports, "auditLink", () => $c072e7e9da7baaac$export$b49df0c9c7ae6e6d);

var $dwTAg = parcelRequire("dwTAg");
const $c072e7e9da7baaac$export$deaa9e6d912ce6c6 = `
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <span class="sr-only">Loading...</span>
`;
function $c072e7e9da7baaac$export$ec267e3635bd0be4(error) {
    console.error(error);
    $('#error-toast-body').text(error);
    new bootstrap.Toast($('#error-toast')).show();
}
function $c072e7e9da7baaac$export$89dc853842deb0b3(message) {
    console.info(`Success: ${message}`);
    $('#success-toast-body').text(message);
    new bootstrap.Toast($('#success-toast')).show();
}
function $c072e7e9da7baaac$export$bfe4ac50319c1d9b(timestamp) {
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString("en-US", {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).replace(' at ', '<br />');
}
function $c072e7e9da7baaac$export$72439bf08da4c934(e) {
    const addressControl = e.currentTarget;
    navigator.clipboard.writeText(addressControl.dataset.bsOriginalTitle);
    addressControl.style.transition = '';
    addressControl.style.setProperty('color', 'green', 'important');
    addressControl.style.opacity = '0.75';
    setTimeout(function() {
        addressControl.style.transition = 'color 1s, opacity 1s';
        addressControl.style.removeProperty('color');
        addressControl.style.opacity = '1';
    }, 50);
    setTimeout(function() {
        addressControl.style.transition = '';
    }, 600);
}
function $c072e7e9da7baaac$export$a2bc61e91eae259f() {
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-bs-toggle="tooltip"]').tooltip();
    $('.pretty-address').click($c072e7e9da7baaac$export$72439bf08da4c934);
}
function $c072e7e9da7baaac$export$b49df0c9c7ae6e6d(chainID, verificationReferenceID) {
    return `<a href="#" onClick="AuditRequest=window.open('${window.location.origin}/audit/?chain-id=${chainID}&verification-reference-id=${verificationReferenceID}','AuditRequest','width=450,height=560'); return false;">${(0, $dwTAg.prettyAddress)(verificationReferenceID, false)}</a>`;
}
var $c072e7e9da7baaac$export$2e2bcd8739ae039 = {
    loadingSpinner: $c072e7e9da7baaac$export$deaa9e6d912ce6c6,
    errorPopup: $c072e7e9da7baaac$export$ec267e3635bd0be4,
    successPopup: $c072e7e9da7baaac$export$89dc853842deb0b3,
    formatTimestamp: $c072e7e9da7baaac$export$bfe4ac50319c1d9b,
    copyAddress: $c072e7e9da7baaac$export$72439bf08da4c934,
    refreshTooltips: $c072e7e9da7baaac$export$a2bc61e91eae259f,
    auditLink: $c072e7e9da7baaac$export$b49df0c9c7ae6e6d
};

});
parcelRegister("dwTAg", function(module, exports) {

$parcel$export(module.exports, "prettyAddress", () => $9d996150ec4a9bef$export$f80bcf15052a775);
function $9d996150ec4a9bef$export$f80bcf15052a775(address, copy = true) {
    if (address === undefined || address.length != 42 && address.length != 66) return address;
    const shortAddress = `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
    return copy ? `<span class="pretty-address" data-toggle="tooltip" data-placement="top" title="${address}">${shortAddress} <i class="fa-solid fa-copy"></i></span>` : shortAddress;
}
var $9d996150ec4a9bef$export$2e2bcd8739ae039 = {
    prettyAddress: $9d996150ec4a9bef$export$f80bcf15052a775
};

});



var $4dFYb = parcelRequire("4dFYb");

var $gwoQm = parcelRequire("gwoQm");

var $dwTAg = parcelRequire("dwTAg");
async function $00479cd0e4056a6a$var$loadPolicy(policy) {
    const policyDetails = (await (0, $4dFYb.showPolicyById)(policy)).result;
    $(`#policy-body-${policy}`).html(policyDetails);
}
async function $00479cd0e4056a6a$var$loadPolicies(policy, methods) {
    $('#policies').append(`
        <article class="policy">
            <div class="toggler" id="${policy}-toggler">
                <h4>${policy} <i class="fa-solid fa-angle-down arrow"></i></h4>
                <ul><li>
                    ${methods.join('</li><li>')}
                </li></ul>
            </div>
            <article class="policy-body" id="policy-body-${policy}" style="display: none">${(0, $gwoQm.loadingSpinner)}</article>
        </article>
    `);
    $(`#${policy}-toggler`).click(function() {
        $(`#policy-body-${policy}`).toggle('slow');
        $(this).find('.arrow').toggleClass('arrow-active');
    });
    $00479cd0e4056a6a$var$loadPolicy(policy);
}
async function $00479cd0e4056a6a$var$buildPolicies(chainid, dappAddress) {
    const policies = (await listPolicies(chainid, dappAddress)).result;
    $('#policies').empty();
    var methodsPerPolicy = {};
    var userPolicy = undefined;
    for (const policy of policies){
        const isUserPolicy = policy.methodId.split('-').length == 2;
        if (isUserPolicy) userPolicy = policy.policyId;
        if (policy.policyId in methodsPerPolicy) {
            if (isUserPolicy) methodsPerPolicy[policy.policyId].unshift(policy.methodInfo);
            else methodsPerPolicy[policy.policyId].push(policy.methodInfo);
        } else methodsPerPolicy[policy.policyId] = [
            policy.methodInfo
        ];
    }
    if (userPolicy !== undefined) $00479cd0e4056a6a$var$loadPolicies(userPolicy, methodsPerPolicy[userPolicy]);
    for (const policy of Object.keys(methodsPerPolicy).sort())if (policy !== userPolicy) $00479cd0e4056a6a$var$loadPolicies(policy, methodsPerPolicy[policy]);
}
async function $00479cd0e4056a6a$var$connectDapp(autoConnect = false) {
    const chainid = $('#chainid-input').val();
    const dappAddress = $('#dapp-address-input').val();
    const prettyDappAddress = (0, $dwTAg.prettyAddress)(dappAddress);
    if (prettyDappAddress === dappAddress) {
        (0, $gwoQm.errorPopup)('Invalid Dapp address');
        return;
    }
    $('#dapp-address').html(prettyDappAddress);
    (0, $gwoQm.refreshTooltips)();
    /* if (!autoConnect)
        successPopup('Dapp connected successfully'); */ $('#dapp-connected-false').hide();
    $('#dapp-connected-true').show();
    $('.require-dapp-connected-true').show();
    await $00479cd0e4056a6a$var$buildPolicies(chainid, dappAddress);
}
$(document).ready(function() {
    window.setBackendUrl = (0, $4dFYb.setBackendUrl);
    window.setAuthUrl = (0, $4dFYb.setAuthUrl);
    window.setDevMode = (0, $4dFYb.setDevMode);
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('chainid')) $('#chainid-input').val(searchParams.get('chainid'));
    if (searchParams.has('address')) $('#dapp-address-input').val(searchParams.get('address'));
    $('#connect-dapp-form').on('submit', function(e) {
        e.preventDefault();
        $00479cd0e4056a6a$var$connectDapp();
    });
    if ($('#chainid-input').val() && $('#dapp-address-input').val()) $00479cd0e4056a6a$var$connectDapp(true);
});


//# sourceMappingURL=index.6f13f158.js.map
